import { ControlTestEdit } from '@client/components/controls/control-test-edit';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/workload-manager/tasks/calendar/details/control_test/$id')({
    staticData: {
        metadata: {
            title: 'Control test details',
        },
        presentation: 'overlay',
    },
    params: {
        parse({ id }) {
            return { id: BigInt(id) };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { id } = Route.useParams();
    const { trpc } = useTrpc();

    // Get the workload item to find the control ID
    const { data: workloadItem } = trpc.workloadManager.listWorkloadItems.useQuery({
        where: { id, workItemType: 'control_test' },
        limit: 1,
        offset: 0,
    });

    const item = workloadItem?.rows[0];

    if (!item) {
        return null;
    }

    return (
        <ControlTestEdit
            action={['edit', id, item.recordId ?? BigInt(0)]}
            onClose={() => window.history.back()}
            workloadItem={item}
        />
    );
}
